/** «Le mie azioni» (QA26-F4.10): le azioni ISO 9001 assegnate a me, da tutte le segnalazioni; filtri nell'URL. */
import { Checkbox, Segmented, Space } from "antd";
import { useSearchParams } from "react-router-dom";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { AzioneDto, PaginaDto } from "@qa/shared";
import { api } from "../../api/client";
import { messaggioErrore } from "../../i18n/errori";
import { PageHead, Vuoto } from "../../components/ui";
import { TabellaAzioni } from "./scheda/Azioni";

export default function AzioniPage() {
  const { t } = useTranslation();
  const [sp, setSp] = useSearchParams();
  const tutte = sp.get("tutte") === "1";
  const f = { mie: tutte ? undefined : true, aperte: sp.get("aperte") === "0" ? undefined : true, scadute: sp.get("scadute") === "1" ? true : undefined, limit: 500 };
  const set = (k: string, v: string | undefined) => {
    const n = new URLSearchParams(sp);
    if (v) n.set(k, v);
    else n.delete(k);
    setSp(n, { replace: true });
  };
  const q = useQuery({ queryKey: ["azioni", f], queryFn: () => api.get<PaginaDto<AzioneDto>>("/redflag/azioni", f), placeholderData: keepPreviousData });
  return (
    <>
      <PageHead
        crumbs={[{ label: t("portale.nome"), to: "/" }, { label: t("menu.gruppoRedflag"), to: "/redflag" }, { label: t("menu.azioni") }]}
        title={tutte ? t("redflag.azioni.tutte") : t("redflag.azioni.mie")}
        sub={t("redflag.azioni.mieSottotitolo")}
      />
      <Space wrap style={{ marginBottom: 14 }}>
        <Segmented
          value={tutte ? "tutte" : "mie"}
          onChange={(v) => set("tutte", v === "tutte" ? "1" : undefined)}
          options={[
            { value: "mie", label: t("redflag.azioni.mie") },
            { value: "tutte", label: t("redflag.azioni.tutte") },
          ]}
        />
        <Checkbox checked={!!f.aperte} onChange={(e) => set("aperte", e.target.checked ? undefined : "0")}>
          {t("redflag.azioni.soloAperte")}
        </Checkbox>
        <Checkbox checked={!!f.scadute} onChange={(e) => set("scadute", e.target.checked ? "1" : undefined)}>
          {t("redflag.azioni.soloScadute")}
        </Checkbox>
      </Space>
      {q.isError ? (
        <Vuoto titolo={messaggioErrore(q.error)} />
      ) : !q.isLoading && !q.data?.righe.length ? (
        <Vuoto titolo={t("redflag.azioni.vuotoElenco")} />
      ) : (
        <TabellaAzioni righe={q.data?.righe ?? []} conSegnalazione loading={q.isFetching} />
      )}
    </>
  );
}
